(() => {
  if(customElements.get('zc-checklist-print'))return;
  customElements.define('zc-checklist-print',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;this.controller=new AbortController();this.closed=null;
      const options={signal:this.controller.signal};
      window.addEventListener('beforeprint',()=>this.prepare(),options);
      window.addEventListener('afterprint',()=>this.restore(),options);
      window.matchMedia('print').addEventListener('change',e=>e.matches?this.prepare():this.restore(),options);
    }
    prepare(){if(this.closed!==null)return;this.previousTitle=document.title;document.title=this.querySelector('.zc-print__document-header h1').textContent.trim();this.closed=[...document.querySelectorAll('.zc-scope details:not([open])')];this.closed.forEach(group=>group.open=true);void document.body.offsetHeight;}
    restore(){this.closed?.forEach(group=>group.open=false);this.closed=null;if(this.previousTitle!==undefined){document.title=this.previousTitle;delete this.previousTitle;}}
    disconnectedCallback(){this.restore();this.controller?.abort();this.controller=null;}
  });
})();
